(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("4twt3", function(module, exports) {
const $34230e3f1a5ba9c3$var$setZIndex = (arr, i, zIndex)=>{
    const item = arr[i];
    if (!item) return;
    item.style.zIndex = zIndex;
};
const $34230e3f1a5ba9c3$var$handleMouseOver = (item, i, arr)=>{
    if (i !== arr.length - 1) {
        item.style.zIndex = "3";
        $34230e3f1a5ba9c3$var$setZIndex(arr, i - 1, "2");
        $34230e3f1a5ba9c3$var$setZIndex(arr, i + 1, "2");
        $34230e3f1a5ba9c3$var$setZIndex(arr, i - 2, "1");
        $34230e3f1a5ba9c3$var$setZIndex(arr, i + 2, "1");
    }
    if (arr[arr.length - 1]) arr[arr.length - 1]?.classList.remove("--last-not-hovered");
};
const $34230e3f1a5ba9c3$var$handleMouseOut = (item, i, arr)=>{
    if (i !== arr.length - 1) {
        item.style.zIndex = "";
        $34230e3f1a5ba9c3$var$setZIndex(arr, i - 1, "");
        $34230e3f1a5ba9c3$var$setZIndex(arr, i + 1, "");
        $34230e3f1a5ba9c3$var$setZIndex(arr, i - 2, "");
        $34230e3f1a5ba9c3$var$setZIndex(arr, i + 2, "");
    }
    if (arr[arr.length - 1]) arr[arr.length - 1]?.classList.add("--last-not-hovered");
};
const $34230e3f1a5ba9c3$var$colorItems = document.querySelectorAll(".i-color__item");
$34230e3f1a5ba9c3$var$colorItems.forEach((item, i, arr)=>{
    item.addEventListener("mouseover", ()=>$34230e3f1a5ba9c3$var$handleMouseOver(item, i, Array.from(arr)));
    item.addEventListener("mouseout", ()=>$34230e3f1a5ba9c3$var$handleMouseOut(item, i, Array.from(arr)));
    if (arr.length > 0) arr[arr.length - 1]?.classList.add("--last-not-hovered");
});

});

})();
//# sourceMappingURL=color-item.864a9338.js.map
